document.addEventListener("DOMContentLoaded", function () {


  const reviewCards = document.querySelectorAll(
    ".vloxo-review-card-v2"
  );


  if (!reviewCards.length) return;



  const observer = new IntersectionObserver(
    function(entries){


      entries.forEach(function(entry){


        if(entry.isIntersecting){


          entry.target.classList.add(
            "review-visible"
          );


          observer.unobserve(
            entry.target
          );


        }


      });



    },
    {
      threshold:0.2
    }


  );




  reviewCards.forEach(function(card,index){


    card.style.transitionDelay =
      `${index * 80}ms`;


    observer.observe(card);



  });





  /*
    Mobile swipe enhancement
  */


  const reviewContainer =
    document.querySelector(
      ".vloxo-reviews-grid-v2"
    );


  if(reviewContainer){


    reviewContainer.addEventListener(
      "touchstart",
      function(){

        reviewContainer.style.scrollBehavior =
        "smooth";

      }

    );


  }




});